export default __webpack_public_path__ + "static/media/6.4b0590f9.png";